module.exports = __webpack_public_path__ + "img/arrow-down-sign-to-navigate.65189a34.png";